<template>
  <div class="tender-list-cell tender-list-cell_low-header-cell">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'TenderListLowHeaderCell',
  };
</script>
